import React, { useEffect, useLayoutEffect, useState, useMemo } from 'react'
import './style.css'

import SuiviDossier from '../Widgets/SuiviDossier'
import SiteTiers from '../Widgets/SiteTiers'
import Reservation from '../Widgets/Reservation'
import Sellsy from '../Widgets/Sellsy'
import Dossier from '../Widgets/Dossier'

import Grid from '@material-ui/core/Grid'
import Utils from 'EurestoFonction/Utils'
import Constants from 'EurestoFonction/Constants'
import User from 'EurestoClass/User'

const widgetsId = {
  5: Dossier,
  1: SuiviDossier,
  13: SiteTiers,
  4: Reservation,
}

const widgetsLibelle = {
  5: 'Dossier',
  1: 'Mes Dossiers',
  13: 'Liens utiles',
  4: 'Réservation',
}

export default React.memo(props => {

  const [widgets, setWidgets] = useState([])

  useEffect(() => {
    dataTraitment();
    console.log(User.User.get().configuration.eurestoweb);
    if(User.User.get().configuration.eurestoweb === "beta") {

       window.location.href = "https://beta.cloud.euresto.io?token=" + localStorage.getItem('token')

    } else 
      initModal();
  }, [])

  const dataTraitment = () => {
    setWidgets(Object.keys(widgetsId)
      .filter(key =>
        (User.TypeAccess.get(Constants.access.EURESTO) && key !== '4') || (User.TypeAccess.get(Constants.access.ETABLISSEMENT) && key === '4' && EurestoOption(Constants.options[Constants.methods.RESTAURANT].id)))
      .map(key => {
        return ({
          id: key,
          size: { min: 50, max: 100 },
          params: {},
          libelle: widgetsLibelle[key],
          actif: 1,
          dashboard_accepted: {}
        })
      })
    )
  }


  const wdgs = useMemo(() => {

     if (widgets !== null && widgets.length >= 1) {

       return Object.keys(widgets).map(key => {
          if (widgets[key]) {
            let style = {
              width: null,
              maxWidth: null,
              height: '400px',
              maxHeight: '400px'
            }

            style.width = widgets[key].size.min + '%'
            style.maxWidth = widgets[key].size.max + '%'
            return React.createElement(widgetsId[widgets[key].id], {
              key: Utils.getRandomNumber(),
              ...widgets[key].params,
              libelle: widgets[key].libelle
            })
      	  }
    	})

     }

     return null;

  }, [widgets])


    return (
      <Grid container spacing={0} style={{ margin: 0, padding: 0 }}>
        <div className="EurestoDivNouvelleInterface" data-url-euresto-route="https://nouvelleversion.euresto.io/" data-token={localStorage.getItem('token')} data-is-button={User.User.get().configuration.eurestoweb ? "true" : "false"}></div>
        {wdgs}
      </Grid>
    )
})



// WEBPACK FOOTER //
// ./app/App/Module/Home/Component/WidgetGrid/index.js